import { useLocation } from 'react-router-dom';

const useGetUrlParams = (paramToFind?: string): any => {
  const { search } = useLocation();
  let searchString: string | null = null;
  const searchParameters: { [key: string]: string } = {};
  const urlSearchParams = new URLSearchParams(search);
  if (paramToFind) {
    searchString = urlSearchParams.get(paramToFind);
  }
  urlSearchParams.forEach((value, key) => (searchParameters[key] = value));
  return { searchString, searchParameters };
};

export default useGetUrlParams;
